import React from "react";
import Button from './button';

function ContactForm() {
  const formLink = '/pricing';
  

  return (
    <div className="p-6">
      <div className="w-full h-[500px] rounded-3xl flex flex-col justify-center items-center py-20 bg-ctaMobile md:bg-ctaDesktop bg-cover bg-center container mx-auto" id="contact">
        <div className="flex flex-col gap-6 items-center justify-center">
          <div className="flex flex-col gap-3 items-center justify-center">
            <h2 className="font-bold text-blue10 text-3xl md:text-5xl font-sans leading-none">Ready to start?</h2>
            <p className="font-sans text-blue20 text-lg leading-8">So are we.</p>
          </div> 
          <Button variant='light-primary' to={formLink} isHashLink={false} label='Find Your Partner' />
        </div>      
      </div>
    </div>
  );
}

export default ContactForm;